<div class="wrapper">
  <p class="mb-0">
    {{ 'page.shift_timeline.zoom_level' | translate }}
  </p>

  <nz-select
    [ngModel]="selectedZoomLevel$ | async"
    [nzPlaceHolder]="'page.shift_timeline.zoom_level' | translate"
    [nzMaxTagCount]="1"
    [nzDropdownStyle]="{ 'min-width': '150px' }"
    nzShowSearch
    [nzShowArrow]="true"
    (ngModelChange)="onSelectedZoomLevel($event)"
  >
    @for (hours of hoursRange; track hours) {
      <nz-option [nzValue]="hours.value" [nzLabel]="hours.name | translate">
      </nz-option>
    }
  </nz-select>
</div>
